import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';
import BreadcrumbNavigation from 'components/ui/BreadcrumbNavigation';
import StaffTable from './components/StaffTable';
import StaffToolbar from './components/StaffToolbar';
import StaffModal from './components/StaffModal';
import StaffDetailsModal from './components/StaffDetailsModal';
import RoleHierarchySidebar from './components/RoleHierarchySidebar';
import { getStaffMembersWithRoles } from 'services/staffService';
import { useSelector } from 'react-redux';

const StaffManagement = () => {
  const [isStaffModalOpen, setIsStaffModalOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [selectedStaffForEdit, setSelectedStaffForEdit] = useState(null);
  const [selectedStaffForDetails, setSelectedStaffForDetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [selectedStaff, setSelectedStaff] = useState([]);
  const selectedBusiness = useSelector((state) => state?.business.selectedBusiness);

  const [staffMembers, setStaffMembers] = useState([]);


  const loadUsers = async ()=>{
    if(!selectedBusiness?.businessId) return;
    const response = await getStaffMembersWithRoles(selectedBusiness.businessId);

    if(response.success && response.data){
      setStaffMembers(response.data);
    }

  }

  // Check authentication
  useEffect(() => {
    // const token = localStorage.getItem('authToken');
    // if (!token) {
    //   navigate('/login');
    // }
    loadUsers();
  }, []);

  // Filter staff members
  const filteredStaff = staffMembers?.filter(staff => {
    const matchesSearch = staff?.fullname?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         staff?.email?.toLowerCase()?.includes(searchTerm?.toLowerCase());
                        //  staff?.employeeId?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesRole = roleFilter === 'all' || (staff?.admin && roleFilter == 'Administrator') || (staff?.releasing && roleFilter == 'Releaser') || (staff?.reporting && roleFilter == 'Reporting') || (staff?.scanning && roleFilter == 'Scanner');
    const matchesStatus = statusFilter === 'all' || staff?.active === (statusFilter=='active'? true:false);
    
    return matchesSearch && matchesRole && matchesStatus;
  });

  const handleAddStaff = () => {
    setModalMode('add');
    setSelectedStaffForEdit(null);
    setIsStaffModalOpen(true);
  };

  const handleEditStaff = (staff) => {
    if(isDetailsModalOpen)
      setIsDetailsModalOpen(false);

    setModalMode('edit');
    setSelectedStaffForEdit(staff);
    setIsStaffModalOpen(true);
  };

  const handleViewDetails = (staff) => {
    setSelectedStaffForDetails(staff);
    setIsDetailsModalOpen(true);
  };

  const handleToggleStatus = (staff) => {
    const newStatus = staff?.status === 'active' ? 'inactive' : 'active';
    setStaffMembers(prev => 
      prev?.map(s => 
        s?.id === staff?.id 
          ? { ...s, status: newStatus }
          : s
      )
    );
  };

  const handleSaveStaff = async (staffData) => {
    setIsStaffModalOpen(false);
    await loadUsers();

    // if (modalMode === 'add') {
    //   // setStaffMembers(prev => [...prev, { ...staffData, id: Date.now() }]);
    //   await loadUsers();
    // } else {
    //   setStaffMembers(prev => 
    //     prev?.map(s => s?.userId === staffData?.userId ? staffData : s)
    //   );
    // }
  };

  const handleSelectStaff = (staffId) => {
    setStaffMembers(prev => 
      prev?.includes(staffId)
        ? prev?.filter(id => id !== staffId)
        : [...prev, staffId]
    );
  };

  const handleSelectAll = () => {
    if (selectedStaff?.length === filteredStaff?.length) {
      setSelectedStaff([]);
    } else {
      setSelectedStaff(filteredStaff?.map(staff => staff?.id));
    }
  };

  const handleBulkAction = (action) => {
    switch (action) {
      case 'activate':
        setStaffMembers(prev => 
          prev?.map(s => 
            selectedStaff?.includes(s?.id) 
              ? { ...s, status: true }
              : s
          )
        );
        break;
      case 'deactivate':
        setStaffMembers(prev => 
          prev?.map(s => 
            selectedStaff?.includes(s?.id) 
              ? { ...s, status: false }
              : s
          )
        );
        break;
      case 'delete':
        if (window.confirm(`Are you sure you want to delete ${selectedStaff?.length} staff member(s)?`)) {
          setStaffMembers(prev => 
            prev?.filter(s => !selectedStaff?.includes(s?.id))
          );
        }
        break;
    }
    setSelectedStaff([]);
  };

  const user = {
    name: 'Admin User',
    email: 'admin@carwash.com',
    role: 'Administrator'
  };

  return (
    <>
       <div className="p-4 lg:p-6">
          {/* Page Header */}
          <div className="mb-6">
            <BreadcrumbNavigation />
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mt-4">
              <div>
                <h1 className="text-2xl lg:text-3xl font-bold text-foreground flex items-center">
                  <Icon name="Users" size={32} className="mr-3 text-primary" />
                  Staff Management
                </h1>
                <p className="text-muted-foreground mt-1">
                  Manage your team members, roles, and permissions
                </p>
              </div>
              
              {/* Quick Stats */}
              <div className="flex items-center space-x-6 text-sm">
                <div className="text-center">
                  <div className="text-lg font-bold text-primary">
                    {staffMembers?.filter(s => s?.active)?.length}
                  </div>
                  <div className="text-muted-foreground">Active</div>
                </div>
                <div className="text-center">
                  <div className="text-lg font-bold text-warning">
                    {staffMembers?.filter(s => !s?.active)?.length}
                  </div>
                  <div className="text-muted-foreground">Inactive</div>
                </div>
                {/* <div className="text-center">
                  <div className="text-lg font-bold text-destructive">
                    {staffMembers?.filter(s => s?.status === 'suspended')?.length}
                  </div>
                  <div className="text-muted-foreground">Suspended</div>
                </div> */}
              </div>
            </div>
          </div>

          {/* Content Layout */}
          <div className="flex flex-col xl:flex-row gap-6">
            {/* Main Content Area */}
            <div className="flex-1 space-y-6">
              {/* Toolbar */}
              <StaffToolbar
                searchTerm={searchTerm}
                onSearchChange={setSearchTerm}
                roleFilter={roleFilter}
                onRoleFilterChange={setRoleFilter}
                statusFilter={statusFilter}
                onStatusFilterChange={setStatusFilter}
                onAddStaff={handleAddStaff}
                selectedCount={selectedStaff?.length}
                onBulkAction={handleBulkAction}
                totalCount={filteredStaff?.length}
              />

              {/* Staff Table */}
              <StaffTable
                staffMembers={filteredStaff}
                onEdit={handleEditStaff}
                onViewDetails={handleViewDetails}
                onToggleStatus={handleToggleStatus}
                selectedStaff={selectedStaff}
                onSelectStaff={handleSelectStaff}
                onSelectAll={handleSelectAll}
                isAllSelected={selectedStaff?.length === filteredStaff?.length && filteredStaff?.length > 0}
              />
            </div>

            {/* Right Sidebar */}
            <div className="xl:w-80">
              <RoleHierarchySidebar staffMembers={staffMembers} onAddStaff={handleAddStaff} />
            </div>
          </div>
        </div>
      {/* Modals */}
      <StaffModal
        isOpen={isStaffModalOpen}
        onClose={() => setIsStaffModalOpen(false)}
        staff={selectedStaffForEdit}
        onSuccessful={handleSaveStaff}
        mode={modalMode}
        business={selectedBusiness}
      />
      <StaffDetailsModal
        isOpen={isDetailsModalOpen}
        onClose={() => setIsDetailsModalOpen(false)}
        staff={selectedStaffForDetails}
        onEdit={handleEditStaff}
      />
    </>
  );
};

export default StaffManagement;